import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { injectCoreFeature } from '@sprint-backoffice/app/core/state/core.store';

@Component({
  selector: 'app-populate-all-documents-lock-indicator',
  standalone: true,
  imports: [CommonModule, MatIcon, MatTooltip],
  template: `
    @if (lockState$$().isLoaded) {
      @if (lockState$$().locked) {
        <div
          class="flex items-center justify-center p-2"
          matTooltip="현재 인덱스 업데이트 중입니다.">
          <mat-icon
            class="absolute animate-ping text-yellow-500"
            svgIcon="mat_outline:radio_button_checked" />
          <mat-icon
            class="text-yellow-500"
            svgIcon="mat_outline:radio_button_checked" />
        </div>
      } @else {
        <div
          class="flex items-center justify-center p-2"
          matTooltip="인덱스 업데이트가 완료되었습니다.">
          <mat-icon
            class="text-green-500"
            svgIcon="mat_outline:radio_button_checked" />
        </div>
      }
    }
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopulateAllDocumentsLockIndicatorComponent implements OnInit {
  readonly core = injectCoreFeature();
  readonly lockState$$ = this.core.populateAllDocumentsLockState$$;

  constructor() {}

  ngOnInit(): void {
    this.core.checkPopulateAllDocumentsLock();
  }
}
